/* eslint-disable no-case-declarations */
import { Message, RobotHanlde } from '@/service/toolClass.js'
import { MessageBox } from 'element-ui';
import Line from "@/service/line.js"
import { update as obserStateUpdate } from '@/code-lab/component/robot-connect/play-button/microstate/playState.js'

import { LoginQuick } from '@/code-lab/component/connection/quick/login.js'
import $store from '@/code-lab/store'
import utils from '@/service/utils.js'
import Vue from 'vue'
let robotCodelabOutMessage = null
export default class SocketHandler {
    constructor(tag, ws, b$) {
        this.lock = false
        this.http = -1
        this.socket = -1
        this.robot = -1
        this.messageInstance = new Message()
        this.lineInstance = new Line()
        this.$store = $store
        this.b$ = b$
        this.activeClose = false
        let playButtonMutations
        import('@/code-lab/component/robot-connect/play-button/observable.js').then(res => playButtonMutations = res.mutations)

        this.httpHanlder = (lastHttpCode) => {
            const http = this.http
            if (http < 1) {
                if (lastHttpCode > 0 && !this.activeClose) { // && !this.activeClose
                    console.log('第一次联网 重连', this.activeClose)
                    this.messageInstance.suspend()
                    this.messageInstance.set('http', { type: 'success', message: Vue.prototype.$t("service/webSocket/socket-handler.js_0"), duration: 5000, close: true, })
                    this.ws.reconnectHandler(0)
                } else {
                    console.log('不是 第一次联网 不重连', this.activeClose)
                }
            } else if (http > 0) {
                this.messageInstance.suspend()
                this.ws.rmoveReconnect()
                this.messageInstance.set("http", { message: Vue.prototype.$t("service/webSocket/socket-handler.js_1"), type: 'error', duration: 0, showClose: true, })
            }
        }

        this.socketHandler = (lastSocketCode) => {
            const socket = this.socket
            console.log({ lastSocketCode, socket }, this.tag)
            if (lastSocketCode === 4999) {
                this.ws.reconnectHandler(0)
            }
            if (socket === 1000) {

                setTimeout(() => {
                    this.socket = 1
                    this.messageInstance.instanceMsg[this.tag] && this.messageInstance.instanceMsg[this.tag].close()
                    if (lastSocketCode !== 1 && !this.lock) {
                        this.messageInstance.set(this.tag, { type: 'error', message: Vue.prototype.$t("service/webSocket/socket-handler.js_2"), duration: 5000, close: true, destroy: true })

                    }

                    this.ws.rmoveReconnect()
                }, 0)

                return console.log("client｜server close socket")
            }

            const abnormal = async () => {
                switch (socket) {
                    case 10002:
                        this.messageInstance.closeAll()
                        this.messageInstance.set('loginRepeat', { type: 'error', message: Vue.prototype.$t("loginRepeat.messageInstance_text"), duration: 0 })
                        this.messageInstance.lock = true
                        console.log('10002', '用户重复登录')
                        MessageBox.confirm(`
                            <div class="tip-icon">
                                <svg width="150" height="150">
                                    <use xlink:href="#codelab-project-unsaved"></use>
                                </svg>
                            </div> ${Vue.prototype.$t("loginRepeat.confirm_text")}`, Vue.prototype.$t("loginRepeat.confirm_title"), {
                            center: true,
                            showClose: false,
                            closeOnClickModal: true,
                            closeOnPressEscape: false,
                            distinguishCancelAndClose: true,
                            dangerouslyUseHTMLString: true,
                            // showCancelButton: false,
                            cancelButtonClass: "codelab-button gray",
                            confirmButtonClass: "codelab-button btn",
                            cancelButtonText: Vue.prototype.$t('LANG_BTN_TEXT_CANCEL_SAVE'),
                            confirmButtonText: Vue.prototype.$t('LANG_BTN_TEXT_CONN_SUCCESS'),
                            customClass: "codelab-important-tip project-unsaved",
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => { });
                        break;
                    case 4998:
                        this.messageInstance.set(this.tag, { message: Vue.prototype.$t("service/webSocket/socket-handler.js_3"), type: 'error', duration: 0, close: true, showClose: true, })
                        setTimeout(() => {
                            this.handleClose(1000, 'client')
                        }, 1000);
                        break;
                    case 4999:
                        await this.checkLine()
                        if (this.http < 1) {
                            this.messageInstance.set(this.tag, { message: Vue.prototype.$t("service/webSocket/socket-handler.js_4"), type: 'warning', duration: 0, close: true, showClose: true, })
                            setTimeout(() => {
                                this.handleClose(1000, 'client')
                            }, 1000);
                        }
                        break;
                    case 4002:
                        this.messageInstance.set(this.tag, { message: Vue.prototype.$t("service/webSocket/socket-handler.js_5"), type: 'error', duration: 0, close: true, showClose: true, })
                        setTimeout(() => {
                            this.handleClose(1000, 'client')
                        }, 1000);
                        break;
                    case 4003:
                        new LoginQuick().loginIn()
                        break;
                    case 4004:
                        this.messageInstance.set(this.tag, { message: Vue.prototype.$t("service/webSocket/socket-handler.js_6"), type: 'error', duration: 0, close: true, showClose: true, })
                        setTimeout(() => {
                            this.handleClose(1000, 'client')
                        }, 1000);
                        break;
                    default:
                        console.log(this.tag)
                        playButtonMutations.status({ status: 0 })
                        setTimeout(() =>
                            this.messageInstance.set(this.tag, { type: 'warning', message: Vue.prototype.$t("service/webSocket/socket-handler.js_7"), duration: 0, close: true, })
                            , 100)
                }
            }
            const recovery = () => {
                switch (socket) {
                    case 1:
                        if (!this.messageInstance.instanceMsg[this.tag]) {
                            setTimeout(() =>
                                this.messageInstance.set(this.tag, { type: 'info', message: Vue.prototype.$t("service/webSocket/socket-handler.js_8"), duration: 0 })
                                , 100)
                        }
                        break;
                    case 2:
                        this.messageInstance.set(this.tag, { type: 'success', message: Vue.prototype.$t("service/webSocket/socket-handler.js_9"), duration: 5000, close: true, })
                        // this.robotHandler()
                        this.socket = 0
                        this.lock = false
                        this.activeClose = false
                        obserStateUpdate({ key: 'inProgressIs', val: 0 })
                        break;
                    case 3:
                        this.messageInstance.set(this.tag, { type: 'success', message: Vue.prototype.$t("service/webSocket/socket-handler.js_10"), duration: 5000, close: true, })
                        // this.robotHandler()
                        this.socket = 0
                        this.lock = false
                        this.activeClose = false
                        obserStateUpdate({ key: 'inProgressIs', val: 0 })
                        break;
                }
            }
            if (socket < 100) {
                recovery()
            } else if (socket > 1000) {
                abnormal()
            }
        }

        this.robotHandler = (lastRobotCode) => {
            const robot = this.robot
            const recovery = () => {
                switch (robot) {
                    case 1:
                        this.messageInstance.set('robot', { type: 'success', message: Vue.prototype.$t("service/webSocket/socket-handler.js_11"), duration: 5000, close: true, })
                        this.robot = 0
                        obserStateUpdate({ key: 'inProgressIs', val: 0 })
                        break;
                    case 2:
                        this.messageInstance.set('robot', { type: 'success', message: Vue.prototype.$t("service/webSocket/socket-handler.js_12"), duration: 5000, close: true, })
                        this.robot = 0

                        obserStateUpdate({ key: 'inProgressIs', val: 0 })
                        break;
                }
                obserStateUpdate({ key: 'buttonLock', val: false })
                if (robotCodelabOutMessage) {
                    console.log("关闭机器人网页编程退出提示")
                    robotCodelabOutMessage.close()
                    robotCodelabOutMessage = null
                }
            }
            const abnormal = () => {
                switch (robot) {
                    case 999:
                        console.log("robotHandler => ", { robot, lastRobotCode })
                        this.messageInstance.set('robot', { message: Vue.prototype.$t("service/webSocket/socket-handler.js_13"), type: 'error', duration: 0, close: true, showClose: true, })
                        setTimeout(() => {
                            console.log("999")
                            this.handleClose(1000, 'client')
                            this.robot = -1
                        }, 1000);
                        break;
                    case 998:
                        console.log({ lastRobotCode, robot }, 'quite')
                        if (this.robot === 0) {
                            console.log(Vue.prototype.$t("service/webSocket/socket-handler.js_14"))
                            break
                        }
                        obserStateUpdate({ key: 'buttonLock', val: true })
                        this.messageInstance.set('robot', { message: Vue.prototype.$t("service/webSocket/socket-handler.js_15"), type: 'error', duration: 0, close: true, showClose: true, })
                        robotCodelabOutMessage = MessageBox
                        new MessageBox({
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            title: Vue.prototype.$t("service/webSocket/socket-handler.js_16"),
                            message: Vue.prototype.$t("service/webSocket/socket-handler.js_17"),
                            showCancelButton: true,
                            confirmButtonText: Vue.prototype.$t("service/webSocket/socket-handler.js_18"),
                            cancelButtonText: Vue.prototype.$t("service/webSocket/socket-handler.js_19"),
                            type: 'warning',
                            showClose: false,
                            callback: (e) => {
                                robotCodelabOutMessage = null
                                if (e === 'confirm') {
                                    // obserStateUpdate({ key: 'inProgressIs', val: 0 })
                                    setTimeout(() => {
                                        new RobotHanlde().set_robot_code_lab_start(tag, b$)
                                    }, 1000);
                                } else {
                                    // obserStateUpdate({ key: 'inProgressIs', val: 0 })
                                    this.handleClose(1000, 'client', true)
                                    this.robot = -1
                                    this.activeClose = true
                                }
                            }
                        })
                        break;
                }
            }
            if (robot < 100) {
                if (lastRobotCode < 0) return console.log('first connect')
                recovery()
            } else if (robot < 1000) {
                abnormal()
            }
        }
        Object.assign(this, { ws, tag })
        this.mount()
        this.visibilitychange()
    }

    async handleClose (code = 1000, reason = 'web', sb) {
        if (!this.lock) {
            this.lock = true
            if(typeof Vue.prototype.closeConnect$ === 'function'){
                Vue.prototype.closeConnect$(sb)
            }
            this.ws.close(code, reason)
        }
    }

    get wsState () {
        return this.ws.readyState < 2
    }

    async checkLine () {
        await this.lineInstance.check().then(() => {
            this.collect('httpCode', 0)
        }).catch(() => {
            this.collect('httpCode', 1)
        })
    }

    collect (type_, code) {
        type_ instanceof Array
            ? type_.forEach((key, inx) => this[key](code[inx]))
            : this[type_](code)
    }

    robotCode (code) {
        const old = this.robot
        this.robot = code
        this.robotHandler(old)
    }

    httpCode (code) {
        const old = this.http
        if (code > 0) {
            this.handleClose(1000, 'client')
        }
        setTimeout(() => {
            this.http = code
            this.httpHanlder(old)
        }, 0)
    }

    socketCode (code) {
        console.log("******socket code:", this.tag, code)
        const old = this.socket
        this.socket = code
        if(this.tag === "quick"){
            this.$store.commit("quickConnection/socketCode", code)
        } else if (this.tag === 'white') {
            this.$store.commit('whiteConnection/socketCode', code)
        }
        if (this.http > 0) return console.log(Vue.prototype.$t( "service/webSocket/socket-handler.js_20" ))
        this.socketHandler(old)
    }

    mount () {
        this.lineInstance.on("online", () => {
            this.checkLine()
        })
        this.lineInstance.on("offline", () => {
            this.checkLine()
        })
    }

    visibilitychange () {
        let hidden, visibilityChange;
        let leaveTime = -1
        let intoTime = -1
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        } else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden";
            visibilityChange = "mozvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        }

        function handleVisibilityChange () {
            if (document[hidden]) {
                console.log('if:', document[hidden], hidden)
                leaveTime = new Date().getTime()
            } else {
                intoTime = new Date().getTime()
                if (this.ws.ws.readyState !== 1 && utils.isMobile$()) {
                    console.log('重连 1 visibilityChange')
                    this.ws.reconnectHandler(0)
                } else {
                    console.log('重连 0 visibilityChange')
                }
                console.log('else:', document[hidden], hidden, {
                    leaveTime, intoTime, ec: (intoTime - leaveTime) / 1000
                }, this.ws, this.ws.ws.readyState, utils.isMobile$())
                // this.ws.reconnectHandler(0)
            }
        }

        if (typeof document.addEventListener === "undefined" || typeof document[hidden] === "undefined") {
            console.error("不支持 visibilitychange 事件");
        } else {
            document.addEventListener(visibilityChange, handleVisibilityChange.bind(this), false);
        }
    }
}
